import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8f9b9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-20" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Add Patient")
const _hoisted_3 = {
  key: 0,
  class: "mt-30"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ATable = _resolveComponent("ATable")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_button, {
        type: "primary",
        shape: "round",
        size: _ctx.size
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/add-patient" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    (_ctx.patients.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(_component_ATable, {
            patients: _ctx.patients,
            deletePatient: _ctx.deletePatient,
            markAsSpecial: _ctx.markAsSpecial
          }, null, 8, ["patients", "deletePatient", "markAsSpecial"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
            : (_openBlock(), _createBlock(_component_a_empty, {
                key: 1,
                class: "mt-90"
              }))
        ]))
  ], 64))
}